exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-3cbae5fb]{margin:20px;max-width:550px}.button[data-v-3cbae5fb]{border:1px solid gray}.spaced[data-v-3cbae5fb]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cbae5fb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_DeleteProduct.vue
// module id = 147
// module chunks = 0